import React, { useState, useEffect } from 'react';
import '../styles/DataTable.css';

const DataTable = ({ data }) => {
  const [rowColors, setRowColors] = useState({});

  useEffect(() => {
    if (data.length > 0) {
      const newRowColors = {};
      const numericFields = ['value', 'putSum', 'putBoundary', 'putITMTable'];
      const numericFieldsReverse = ['callSum', 'difference', 'callBoundary', 'callITMTable'];


      data.forEach((currentRow, idx) => {
        if(idx === 0 && data.length === 1){
            newRowColors[idx] = {};
            return;
        }

        if(idx === 0 && data.length > 1){
            const previousRow = data[idx + 1];
            const cellColors = {};

            numericFields.forEach((field) => {
                const currentValue = currentRow[field];
                const previousValue = previousRow[field];

                if(typeof currentValue === 'number' && typeof previousValue === 'number') {
                    if(currentValue > previousValue) {
                        cellColors[field] = 'cell-increase'; // Green
                    } else if (currentValue < previousValue) {
                        cellColors[field] = 'cell-decrease'; // Red
                    } else {
                        cellColors[field] = 'cell-unchanged'; // No change
                    }
                }
            });

            numericFieldsReverse.forEach((field) => {
                const currentValue = currentRow[field];
                const previousValue = previousRow[field];

                if(typeof currentValue === 'number' && typeof previousValue === 'number') {
                    if(currentValue < previousValue) {
                        cellColors[field] = 'cell-increase'; // Green
                    } else if (currentValue > previousValue) {
                        cellColors[field] = 'cell-decrease'; // Red
                    } else {
                        cellColors[field] = 'cell-unchanged'; // No change
                    }
                }
            });

            newRowColors[idx] = cellColors;
        } else if (idx > 0) {
            //All other rows compare with previous row
            const previousRow = data[idx - 1];
            const cellColors = {};

            numericFields.forEach((field) => {
                const currentValue = currentRow[field];
                const previousValue = previousRow[field];

                if(typeof currentValue === 'number' && typeof previousValue === 'number') {
                    if(currentValue > previousValue) {
                        cellColors[field] = 'cell-increase'; // Green
                    } else if (currentValue < previousValue) {
                        cellColors[field] = 'cell-decrease'; // Red
                    } else {
                            cellColors[field] = 'cell-unchanged'; // No change
                        }
                    }
             });

            numericFieldsReverse.forEach((field) => {
                const currentValue = currentRow[field];
                const previousValue = previousRow[field];

                if(typeof currentValue === 'number' && typeof previousValue === 'number') {
                    if(currentValue < previousValue) {
                        cellColors[field] = 'cell-increase'; // Green
                    } else if (currentValue > previousValue) {
                        cellColors[field] = 'cell-decrease'; // Red
                    } else {
                        cellColors[field] = 'cell-unchanged'; // No change
                    }
                }
            });

            newRowColors[idx] = cellColors;
        }

      });
      setRowColors(newRowColors);
    }
  }, [data]);

  const getCellClass = (rowIdx, field) => {
    return rowColors[rowIdx]?.[field] || '';
  };

  return (
    <div className="data-table">
      <table>
        <thead>
          <tr>
            <th>Time</th>
            <th>Value</th>
            <th>Call Sum</th>
            <th>Put Sum</th>
            <th>Difference</th>
            <th>Call Boundary</th>
            <th>Put Boundary</th>
            <th>Call ITM</th>
            <th>Put ITM</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan="9" className="no-data">
                No data available. Click Start to begin analysis.
              </td>
            </tr>
          ) : (
            data.map((row, idx) => (
              <tr key={idx}>
                <td>{row.time}</td>
                <td className={getCellClass(idx, 'value')}>{row.value?.toFixed(2)}</td>
                <td className={getCellClass(idx, 'callSum')}>{row.callSum?.toFixed(2)}</td>
                <td className={getCellClass(idx, 'putSum')}>{row.putSum?.toFixed(2)}</td>
                <td className={getCellClass(idx, 'difference')}>{row.difference?.toFixed(2)}</td>
                <td className={getCellClass(idx, 'callBoundary')}>{row.callBoundary?.toFixed(2)}</td>
                <td className={getCellClass(idx, 'putBoundary')}>{row.putBoundary?.toFixed(2)}</td>
                <td className={getCellClass(idx, 'callITMTable')}>{row.callITMTable?.toFixed(2)}</td>
                <td className={getCellClass(idx, 'putITMTable')}>{row.putITMTable?.toFixed(2)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
